import React from 'react';
import { useInitiateOtp } from './hooks';
import { useSignupVerifyEmailOtpState } from '../otp/hooks';
import { SendOtpEmailInterstitial } from '../../../../components/SendOtpEmailInterstitial/SendOtpEmailInterstitial';
import { INITIATE_OTP_PAGE_ID } from './constants';
import { fetchPageState } from '../../../../utilities/fetch-api';

export async function signupInitiateOtpLoader({ request }: { request: Request }) {
  return await fetchPageState('/rest/signup/verify-email/initiate-otp/state', request, {
    capabilities: ['capability-group--signup', 'capability-name--verify-email'],
  });
}

export const InitiateOtpPage = () => {
  const { onSendVerificationEmail, isLoading, errorCode } = useInitiateOtp();
  const { email } = useSignupVerifyEmailOtpState();

  return (
    <SendOtpEmailInterstitial
      pageId={INITIATE_OTP_PAGE_ID}
      email={email}
      isLoading={isLoading}
      errorCode={errorCode}
      onSendVerificationEmail={onSendVerificationEmail}
    />
  );
};

export default InitiateOtpPage;
